import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';
import * as Track from '@project/shared/utils/tracking/js/tracking';

@createModule('Button')
/**
 * Button Component
 * @constructor
 */
export class Button extends TerrificSpec {
	/**
	 * start/init Nitro lifecycle hook
	 * @param {function} resolve - Required parameter for start lifecycle
	 * @returns {void} void
	 */
	start(resolve: () => void): void {
		if (this.isScrollTopBtn()) {
			this._ctx.addEventListener('click', () => this.scrollToTop());
		}

		// this._ctx.addEventListener('click', (event: Event) => {
		// 	this.downloadButtonClicked(event);
		// });
		resolve();
	}

	/**
	 * stop/destroy Nitro lifecycle hook
	 * @returns {void}
	 */
	stop() {
		if (this.isScrollTopBtn()) {
			this._ctx.removeEventListener('click', () => {});
		}
	}

	/**
	 * Scroll to top of the document
	 * @returns {void}
	 */
	scrollToTop() {
		scrollToElement($(document.body), false, 0);
	}

	downloadButtonClicked(event: Event) {
		const $target = $(event.target).attr('href');
		const $flowId = $(event.target).data('cdcflow-id');
		if ($target !== undefined && $target.indexOf('/api/tds') == -1) {
			event.preventDefault();
			this.handleDownloadFile($target, $flowId);
		}
	}

	handleDownloadFile(fileUrl: any, flowId: any) {
		if (flowId) {
			if (Track.isKnownCdcLead()) {
				window.open(fileUrl, '_blank');
			}
		} else {
			window.open(fileUrl, '_blank');
		}
	}

	/**
	 * back-to-top button should contain the 'a-button--top' css class that comes from the button modifier 'top'
	 * to separate its click event
	 * @returns {boolean} boolean
	 */
	isScrollTopBtn(): boolean {
		return this._ctx.classList.contains('a-button--top');
	}
}
